// extracted by mini-css-extract-plugin
module.exports = {"highlightBg":"RenderText_highlightBg__2l2zf","oswald":"RenderText_oswald__1lzaU","opensans":"RenderText_opensans__2DRO5","gordita":"RenderText_gordita__2lajd"};